export type AudioContainerMode = {
	name: 'expanded' | 'minified';
	width: number; // pixels
};

export const AUDIO_CONTAINER_MODES: Record<string, AudioContainerMode> = {
	EXPANDED: {
		name: 'expanded',
		width: 380,
	},
	MINIFIED: {
		name: 'minified',
		width: 274,
	},
} as const satisfies Record<string, AudioContainerMode>;
